"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var TimesSolid = function TimesSolid(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "times-solid",
    viewBox: "0 0 18 18"
  }, rest), react_1["default"].createElement("g", {
    id: "Pages",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    id: "Mobile---Menu",
    transform: "translate(-284.000000, -18.000000)",
    fill: "currentColor"
  }, react_1["default"].createElement("path", {
    d: "M294,26 L304,26 L304,28 L294,28 L294,38 L292,38 L292,28 L282,28 L282,26 L292,26 L292,16 L294,16 L294,26 Z",
    id: "Combined-Shape",
    transform: "translate(293.000000, 27.000000) rotate(-45.000000) translate(-293.000000, -27.000000) "
  }))));
};

exports["default"] = TimesSolid;